import React, { useState } from 'react';

function PricingPage({ session, onSignOut, userPlan }) {
  const [loading, setLoading] = useState(null);
  const isUpgrade = userPlan === 'starter';

  const handleCheckout = async (priceId, planName) => {
    setLoading(planName);
    const response = await fetch('https://alphabioai-backend.onrender.com/create-checkout-session', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
  priceId: priceId,
  customerEmail: session.user.email,
  isUpgrade: isUpgrade,
}),
    });
    const data = await response.json();
    window.location.href = data.url;
  };

  const plans = [
    {
      name: 'Starter',
      price: '$19',
      priceId: process.env.REACT_APP_STRIPE_STARTER_PRICE_ID,
      description: 'Everything you need to invest smarter in biotech.',
      features: [
        { text: 'Full FDA Drug Pipeline (1,000+ drugs)', live: true },
        { text: 'AI Summaries & Risk Scoring', live: true },
        { text: 'Clinical Trials Feed', live: true },
        { text: 'FDA Calendar & PDUFA Dates', live: true },
        { text: 'Insider Trading Tracker', live: true },
        { text: 'Portfolio Tracker', live: true },
        { text: 'Earnings + FDA Collision Detector', live: true },
        { text: 'Weekly Email Digest', live: true },
        { text: 'Email Support', live: true },
      ],
      color: '#38bdf8',
      popular: false,
    },
    {
      name: 'Pro',
      price: '$49',
      priceId: process.env.REACT_APP_STRIPE_PRO_PRICE_ID,
      description: "For serious investors who want every edge, including what's next.",
      features: [
        { text: 'Everything in Starter', live: true },
        { text: 'Personalized AI Watchlist Brief', live: true },
        { text: 'Watchlist + Price Alerts', live: true },
        { text: 'Pre-PDUFA Positioning Reports', live: true },
        { text: 'Company Intelligence Profiles', live: true },
        { text: 'Early access to all new features', live: true },
        { text: 'ML Risk Score (proprietary, 1–5 scale) — coming soon', live: false },
        { text: 'SEC Filing Analysis — coming soon', live: false },
        { text: 'Unlimited Alerts', live: true },
        { text: 'Priority Support', live: true },
      ],
      color: '#a78bfa',
      popular: true,
    }
  ];

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#060d1e',
      color: '#f0f6ff',
      fontFamily: "'Inter', system-ui, sans-serif",
    }}>
      {/* Background glow */}
      <div style={{ position: 'fixed', inset: 0, background: 'radial-gradient(ellipse 80% 50% at 50% -10%, rgba(16,185,129,0.07) 0%, transparent 60%)', pointerEvents: 'none', zIndex: 0 }} />

      {/* Header */}
      <div style={{ position: 'relative', zIndex: 1, backgroundColor: 'rgba(13,26,45,0.95)', padding: '18px 40px', borderBottom: '1px solid #1e3a5f', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backdropFilter: 'blur(12px)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{ width: 32, height: 32, background: 'linear-gradient(135deg, #10b981, #3b82f6)', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <svg width="18" height="18" viewBox="0 0 32 32" fill="none">
              <polyline points="3,17 7,17 9,17 11,11 13,23 15,16 17,16 19,13 21,18 23,16 26,16 29,14" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <span style={{ fontSize: '18px', fontWeight: '800', color: '#f0f6ff', letterSpacing: '-0.3px' }}>
            Alpha<span style={{ color: '#10b981' }}>Bio</span><span style={{ fontWeight: '300', color: '#8ba5c8' }}>AI</span>
          </span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <span style={{ fontSize: '13px', color: '#8ba5c8' }}>{session.user.email}</span>
          <button onClick={onSignOut} style={{ backgroundColor: 'transparent', border: '1px solid #1e3a5f', color: '#8ba5c8', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer', fontSize: '13px', transition: 'all 0.2s' }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = '#ef4444'; e.currentTarget.style.color = '#ef4444'; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = '#1e3a5f'; e.currentTarget.style.color = '#8ba5c8'; }}>
            Sign Out
          </button>
        </div>
      </div>

      {/* Pricing content */}
      <div style={{ position: 'relative', zIndex: 1, textAlign: 'center', padding: '60px 40px' }}>

        {isUpgrade ? (
          <>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', backgroundColor: 'rgba(167,139,250,0.08)', border: '1px solid rgba(167,139,250,0.25)', color: '#a78bfa', padding: '8px 20px', borderRadius: '100px', fontSize: '13px', fontWeight: '700', marginBottom: '24px' }}>
              Upgrade your plan
            </div>
            <h2 style={{ fontSize: '36px', fontWeight: '800', marginBottom: '12px', letterSpacing: '-1px', color: '#f0f6ff' }}>Upgrade to Pro</h2>
            <p style={{ color: '#8ba5c8', fontSize: '16px', marginBottom: '8px' }}>Get the full AlphaBioAI experience — AI briefs, unlimited alerts, and early access to every new feature.</p>
            <p style={{ color: '#4a6a8a', fontSize: '13px', marginBottom: '48px' }}>Your existing subscription will be upgraded immediately.</p>
          </>
        ) : (
          <>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', backgroundColor: 'rgba(16,185,129,0.08)', border: '1px solid rgba(16,185,129,0.25)', color: '#10b981', padding: '8px 20px', borderRadius: '100px', fontSize: '13px', fontWeight: '700', marginBottom: '24px' }}>
              7-day free trial — no charge until day 8
            </div>
            <h2 style={{ fontSize: '36px', fontWeight: '800', marginBottom: '12px', letterSpacing: '-1px', color: '#f0f6ff' }}>Start Your Free Trial</h2>
            <p style={{ color: '#8ba5c8', fontSize: '16px', marginBottom: '8px' }}>Institutional-grade biotech intelligence at a fraction of the cost</p>
            <p style={{ color: '#4a6a8a', fontSize: '13px', marginBottom: '48px' }}>Try free for 7 days. Cancel anytime before day 8 and you won't be charged a thing.</p>
          </>
        )}

        <div style={{ display: 'flex', gap: '24px', justifyContent: 'center', flexWrap: 'wrap' }}>
          {plans.map((plan) => {
            const isCurrentPlan = isUpgrade && plan.name === 'Starter';
            const isTargetPlan  = isUpgrade && plan.name === 'Pro';
            return (
              <div key={plan.name} style={{
                backgroundColor: '#0d1a2d',
                borderRadius: '18px',
                padding: '36px 32px',
                width: '300px',
                border: plan.popular ? `2px solid ${plan.color}` : '1px solid #1e3a5f',
                position: 'relative',
                opacity: isCurrentPlan ? 0.5 : 1,
                transition: 'all 0.2s',
              }}>
                {plan.popular && !isUpgrade && (
                  <div style={{ position: 'absolute', top: '-12px', left: '50%', transform: 'translateX(-50%)', backgroundColor: plan.color, color: 'white', padding: '4px 16px', borderRadius: '20px', fontSize: '11px', fontWeight: '800', whiteSpace: 'nowrap', letterSpacing: '0.5px' }}>
                    EARLY ADOPTER
                  </div>
                )}
                {isTargetPlan && (
                  <div style={{ position: 'absolute', top: '-12px', left: '50%', transform: 'translateX(-50%)', backgroundColor: plan.color, color: 'white', padding: '4px 16px', borderRadius: '20px', fontSize: '11px', fontWeight: '800', whiteSpace: 'nowrap', letterSpacing: '0.5px' }}>
                    RECOMMENDED
                  </div>
                )}
                {isCurrentPlan && (
                  <div style={{ position: 'absolute', top: '-12px', left: '50%', transform: 'translateX(-50%)', backgroundColor: '#1e3a5f', color: '#8ba5c8', padding: '4px 16px', borderRadius: '20px', fontSize: '11px', fontWeight: '800', whiteSpace: 'nowrap' }}>
                    CURRENT PLAN
                  </div>
                )}

                <h3 style={{ color: plan.color, margin: '0 0 8px', fontSize: '16px', fontWeight: '700' }}>{plan.name}</h3>
                <div style={{ fontSize: '52px', fontWeight: '900', margin: '16px 0 4px', color: '#f0f6ff', letterSpacing: '-2px', lineHeight: 1 }}>
                  {plan.price}<span style={{ fontSize: '16px', color: '#8ba5c8', fontWeight: '400' }}>/mo</span>
                </div>
                {!isUpgrade && (
                  <div style={{ fontSize: '12px', color: '#10b981', fontWeight: '700', marginBottom: '16px' }}>
                    7 days free, then {plan.price}/mo
                  </div>
                )}
                <p style={{ color: '#8ba5c8', fontSize: '13px', margin: '12px 0 20px', lineHeight: '1.6' }}>
                  {plan.description}
                </p>

                <div style={{ borderTop: '1px solid #1e3a5f', paddingTop: '20px', marginBottom: '24px', display: 'flex', flexDirection: 'column', gap: '10px', textAlign: 'left' }}>
                  {plan.features.map((f, j) => (
                    <div key={j} style={{ display: 'flex', gap: '10px', alignItems: 'flex-start', fontSize: '13px', color: f.live ? '#c8deff' : '#4a6a8a', lineHeight: 1.5 }}>
                      <span style={{ color: f.live ? plan.color : '#2d5a8e', fontWeight: '700', fontSize: '13px', flexShrink: 0, marginTop: '1px' }}>{f.live ? '✓' : '·'}</span>
                      {f.text}
                    </div>
                  ))}
                </div>

                <button
                  onClick={() => !isCurrentPlan && handleCheckout(plan.priceId, plan.name)}
                  disabled={loading === plan.name || isCurrentPlan}
                  style={{
                    width: '100%',
                    backgroundColor: isCurrentPlan ? '#1e3a5f' : plan.popular ? plan.color : 'transparent',
                    color: isCurrentPlan ? '#4a6a8a' : plan.popular ? 'white' : plan.color,
                    border: `1px solid ${isCurrentPlan ? '#1e3a5f' : plan.color}`,
                    padding: '14px',
                    borderRadius: '10px',
                    cursor: isCurrentPlan ? 'default' : loading === plan.name ? 'not-allowed' : 'pointer',
                    fontWeight: '700',
                    fontSize: '15px',
                    fontFamily: 'inherit',
                    opacity: loading === plan.name ? 0.7 : 1,
                    transition: 'all 0.2s',
                  }}
                >
                  {isCurrentPlan ? 'Current Plan' :
                   loading === plan.name ? 'Redirecting...' :
                   isUpgrade && plan.name === 'Pro' ? 'Upgrade to Pro →' :
                   'Start 7-Day Free Trial'}
                </button>
              </div>
            );
          })}
        </div>

        <p style={{ color: '#2d5a8e', fontSize: '12px', marginTop: '32px' }}>
          {isUpgrade ? 'Upgrade takes effect immediately.' : 'No charge for 7 days. Cancel anytime. Card required to start trial.'}
        </p>
      </div>
    </div>
  );
}

export default PricingPage;